import React from 'react';
import Items from '../Items';
import { LessonBlock } from '../types';

export default function DefaultBlock({ block }: { block: LessonBlock }) {
  return <Items items={block.items || []} />;
}
